var render = function render(_c,_vm){return _c('span',{staticClass:"VToggle",class:{
        'VToggle_vertical-toggle': _vm.props.isVerticalToggle,
        'VToggle_vertical': _vm.props.isVertical,
    }},[_c('span',{staticClass:"VToggle__label"},[_vm._v(_vm._s(_vm.props.label))]),_c('span',{staticClass:"VToggle__switch",class:{'VToggle__switch_active':_vm.props.checked},on:{"click":function($event){_vm.props.sync ? _vm.listeners.change(!_vm.props.checked) :_vm.listeners.click ? _vm.listeners.click() : null}}}),_c('span',{staticClass:"VToggle__label-after"},[_vm._v(_vm._s(_vm.props.labelAfter))])])
}
var staticRenderFns = []

export { render, staticRenderFns }